import { c as _c } from "react/compiler-runtime";
import { keyframes, Theme, ThemeContext } from '@emotion/react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { themeGet } from '@styled-system/theme-get';
import Tippy from '../tooltip';
import Color from 'color';
import React from 'react';
import * as StyledSystem from 'styled-system';
import { variant } from 'styled-system';
import { Box, BoxKnownProps, BoxProps } from '../grid';
const rotate = keyframes({
  '0%': {
    transform: 'rotate(0deg) scale(1)'
  },
  '50%': {
    transform: 'rotate(180deg) scale(1)'
  },
  '100%': {
    transform: 'rotate(360deg) scale(1)'
  }
});
const loadingStyle = theme => ({
  position: 'relative',
  '&:before': {
    content: '""',
    display: 'inline-block',
    position: 'absolute',
    border: `4px solid ${theme.colors.gray[3]}`,
    borderLeftColor: 'white',
    borderRadius: '50%',
    boxSizing: 'border-box',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-12px',
    width: '24px',
    height: '24px',
    animation: `${rotate} 1s linear infinite`
  }
});
interface ButtonKnownProps extends BoxKnownProps, StyledSystem.ButtonStyleProps {}
export interface ButtonProps extends ButtonKnownProps, Omit<React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, keyof ButtonKnownProps> {
  color?: string;
  colorScheme?: 'brand0' | 'brand1' | 'brand2' | 'brand3' | 'gray' | 'green' | 'yellow' | 'red';
  // colorOffset?: number;
  iconColor?: string;
  variant?: 'solid' | 'outlined' | 'flat';
  size?: 'large' | 'medium' | 'small';
  active?: boolean;
  loading?: boolean;
  iconLeft?: IconProp;
  iconRight?: IconProp;
  iconPadding?: any;
  fixedWidth?: boolean;
}
const sizeVariant = variant({
  prop: 'size',
  scale: 'buttonSizes'
  // variants: {
  //   // can be blank to enable the new API
  //   large: {
  //     fontSize: 3,
  //   },
  //   medium: {
  //     fontSize: 2,
  //   },
  //   small: {
  //     fontSize: 1,
  //   },
  // },
});
const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
export function Button(t0) {
  const $ = _c(80);
  const {
    ref,
    children,
    color: t1,
    iconColor: t2,
    active,
    loading,
    iconLeft,
    iconRight,
    type: t3,
    disabled,
    fixedWidth,
    iconPadding: t4,
    variant: t5,
    ...props
  } = t0;
  const buttonColor = t1 === undefined ? "primary" : t1;
  t2 === undefined ? buttonColor : t2;
  const type = t3 === undefined ? "button" : t3;
  const iconPadding = t4 === undefined ? "0.5em" : t4;
  const variant_ = t5 === undefined ? "solid" : t5;
  const theme = React.useContext(ThemeContext) as Theme;
  const isDark = theme.mode === "dark";
  const variant = variant_ || "solid";
  let activeStyle;
  let bg = "transparent";
  let color;
  let borderColor = "transparent";
  if (buttonColor.startsWith("#")) {
    debugger;
  }
  let t6;
  if ($[0] !== buttonColor) {
    t6 = buttonColor.split(".");
    $[0] = buttonColor;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const [scale, index] = t6;
  let t7;
  if ($[2] !== scale) {
    t7 = {
      success: "green",
      warning: "yellow",
      alert: "red",
      primary: "primary_",
      secondary: "gray"
    }[scale] || scale;
    $[2] = scale;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const colorScale = t7;
  let scaleIndex;
  bb0: switch (variant) {
    default:
    case "solid":
      {
        if (isDark) {
          let t8;
          if ($[4] !== colorScale || $[5] !== index) {
            t8 = index ? Number(index) : {
              gray: 3,
              red: 6,
              primary_: 5,
              brand1: 6
            }[colorScale] || 8;
            $[4] = colorScale;
            $[5] = index;
            $[6] = t8;
          } else {
            t8 = $[6];
          }
          scaleIndex = t8;
        } else {
          let t8;
          if ($[7] !== colorScale || $[8] !== index) {
            t8 = index ? Number(index) : {
              gray: 1,
              red: 6,
              brand1: 4
            }[colorScale] || 8;
            $[7] = colorScale;
            $[8] = index;
            $[9] = t8;
          } else {
            t8 = $[9];
          }
          scaleIndex = t8;
        }
        const baseColorN_1 = clamp(scaleIndex + (isDark ? -1 : 0), 0, 9);
        const t8 = baseColorN_1 + (isDark ? -1 : 1);
        let t9;
        if ($[10] !== t8) {
          t9 = clamp(t8, 0, 9);
          $[10] = t8;
          $[11] = t9;
        } else {
          t9 = $[11];
        }
        const activeColorN = t9;
        const baseColor_0 = `${colorScale}.${baseColorN_1}`;
        const darkenColor = `${colorScale}.${activeColorN}`;
        bg = baseColor_0;
        borderColor = baseColor_0;
        if (isDark ? baseColorN_1 > 6 : baseColorN_1 < 4) {
          color = theme.colors.black;
        } else {
          color = theme.colors.white;
        }
        let t10;
        if ($[12] !== color || $[13] !== darkenColor) {
          t10 = {
            color,
            backgroundColor: darkenColor,
            borderColor: darkenColor
          };
          $[12] = color;
          $[13] = darkenColor;
          $[14] = t10;
        } else {
          t10 = $[14];
        }
        activeStyle = t10;
        break bb0;
      }
    case "outlined":
      {
        if (isDark) {
          let t8;
          if ($[15] !== colorScale || $[16] !== index) {
            t8 = index ? Number(index) : {
              primary_: 7,
              red: 7
            }[colorScale] || 7;
            $[15] = colorScale;
            $[16] = index;
            $[17] = t8;
          } else {
            t8 = $[17];
          }
          scaleIndex = t8;
        } else {
          let t8;
          if ($[18] !== colorScale || $[19] !== index) {
            t8 = index ? Number(index) : {
              red: 7
            }[colorScale] || 8;
            $[18] = colorScale;
            $[19] = index;
            $[20] = t8;
          } else {
            t8 = $[20];
          }
          scaleIndex = t8;
        }
        const t8 = scaleIndex + (isDark ? -1 : 0);
        let t9;
        if ($[21] !== t8) {
          t9 = clamp(t8, 0, 9);
          $[21] = t8;
          $[22] = t9;
        } else {
          t9 = $[22];
        }
        const baseColorN_0 = t9;
        isDark ? 0 : 0;
        const baseColor = `${colorScale}.${baseColorN_0}`;
        const fadeColor = `${colorScale}.${0}`;
        const t10 = scaleIndex - 5;
        let t11;
        if ($[23] !== t10) {
          t11 = clamp(t10, 0, 9);
          $[23] = t10;
          $[24] = t11;
        } else {
          t11 = $[24];
        }
        const borderColorN = t11;
        const lighterBorderColor = `${colorScale}.${borderColorN}`;
        color = baseColor;
        borderColor = lighterBorderColor;
        let t12;
        if ($[25] !== color || $[26] !== fadeColor) {
          t12 = {
            backgroundColor: fadeColor,
            color
          };
          $[25] = color;
          $[26] = fadeColor;
          $[27] = t12;
        } else {
          t12 = $[27];
        }
        activeStyle = t12;
        break bb0;
      }
    case "flat":
      {
        if (isDark) {
          let t8;
          if ($[28] !== colorScale || $[29] !== index) {
            t8 = index ? Number(index) : {
              primary_: 7,
              red: 7
            }[colorScale] || 7;
            $[28] = colorScale;
            $[29] = index;
            $[30] = t8;
          } else {
            t8 = $[30];
          }
          scaleIndex = t8;
        } else {
          let t8;
          if ($[31] !== colorScale || $[32] !== index) {
            t8 = index ? Number(index) : {
              red: 7
            }[colorScale] || 8;
            $[31] = colorScale;
            $[32] = index;
            $[33] = t8;
          } else {
            t8 = $[33];
          }
          scaleIndex = t8;
        }
        const t8 = scaleIndex + (isDark ? -1 : 0);
        let t9;
        if ($[34] !== t8) {
          t9 = clamp(t8, 0, 9);
          $[34] = t8;
          $[35] = t9;
        } else {
          t9 = $[35];
        }
        const baseColorN = t9;
        isDark ? 0 : 0;
        color = `${colorScale}.${baseColorN}`;
        const t10 = `${colorScale}.${0}`;
        let t11;
        if ($[36] !== color || $[37] !== t10) {
          t11 = {
            backgroundColor: t10,
            color
          };
          $[36] = color;
          $[37] = t10;
          $[38] = t11;
        } else {
          t11 = $[38];
        }
        activeStyle = t11;
      }
  }
  const T0 = Box;
  const t8 = "button";
  const t9 = "buttons";
  const t10 = disabled || loading;
  const t11 = "block";
  const t12 = "none";
  const t13 = "center";
  const t14 = "inherit";
  const t15 = "none";
  const t16 = "pointer";
  const t17 = "hidden";
  const t18 = "all 0.25s ease-out, color 0.25s ease-out";
  let t19;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      opacity: 0.5
    };
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  const t20 = 2;
  let t21;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      lineHeight: 1
    };
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  const t22 = 1;
  const t23 = color;
  const t24 = bg;
  const t25 = borderColor;
  const t26 = "solid";
  const t27 = activeStyle;
  const t28 = `solid 2px ${theme.colors.brand0[isDark ? 7 : 3]}`;
  let t29;
  if ($[41] !== t28) {
    t29 = {
      outline: t28
    };
    $[41] = t28;
    $[42] = t29;
  } else {
    t29 = $[42];
  }
  const t30 = sizeVariant({
    ...props,
    size: props.size || "medium",
    theme
  });
  let t31;
  if ($[43] !== active || $[44] !== activeStyle) {
    t31 = active ? activeStyle : {};
    $[43] = active;
    $[44] = activeStyle;
    $[45] = t31;
  } else {
    t31 = $[45];
  }
  let t32;
  if ($[46] !== loading || $[47] !== theme) {
    t32 = loading ? loadingStyle(theme) : "";
    $[46] = loading;
    $[47] = theme;
    $[48] = t32;
  } else {
    t32 = $[48];
  }
  let t33;
  if ($[49] !== activeStyle || $[50] !== bg || $[51] !== borderColor || $[52] !== color || $[53] !== t19 || $[54] !== t21 || $[55] !== t29 || $[56] !== t30 || $[57] !== t31 || $[58] !== t32) {
    t33 = {
      display: t11,
      appearance: t12,
      textAlign: t13,
      lineHeight: t14,
      textDecoration: t15,
      cursor: t16,
      overflow: t17,
      transition: t18,
      "&:disabled": t19,
      borderRadius: t20,
      "&, *": t21,
      borderWidth: t22,
      color: t23,
      bg: t24,
      borderColor: t25,
      borderStyle: t26,
      "&:active, &:focus, &:hover": t27,
      "&:focus": t29,
      ...t30,
      ...t31,
      ...t32
    };
    $[49] = activeStyle;
    $[50] = bg;
    $[51] = borderColor;
    $[52] = color;
    $[53] = t19;
    $[54] = t21;
    $[55] = t29;
    $[56] = t30;
    $[57] = t31;
    $[58] = t32;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== children || $[61] !== fixedWidth || $[62] !== iconLeft || $[63] !== iconPadding) {
    t34 = iconLeft && <Box sx={{
      mr: children ? iconPadding : 0,
      display: "inline"
    }}><FontAwesomeIcon icon={iconLeft} fixedWidth={fixedWidth} /></Box>;
    $[60] = children;
    $[61] = fixedWidth;
    $[62] = iconLeft;
    $[63] = iconPadding;
    $[64] = t34;
  } else {
    t34 = $[64];
  }
  let t35;
  if ($[65] !== children || $[66] !== fixedWidth || $[67] !== iconPadding || $[68] !== iconRight) {
    t35 = iconRight && <Box sx={{
      ml: children ? iconPadding : 0,
      display: "inline"
    }}><FontAwesomeIcon icon={iconRight} fixedWidth={fixedWidth} /></Box>;
    $[65] = children;
    $[66] = fixedWidth;
    $[67] = iconPadding;
    $[68] = iconRight;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  let t36;
  if ($[70] !== T0 || $[71] !== children || $[72] !== props || $[73] !== ref || $[74] !== t10 || $[75] !== t33 || $[76] !== t34 || $[77] !== t35 || $[78] !== type) {
    t36 = <T0 ref={ref} as={t8} tx={t9} type={type} disabled={t10} __css={t33} {...props}>{t34}{children}{t35}</T0>;
    $[70] = T0;
    $[71] = children;
    $[72] = props;
    $[73] = ref;
    $[74] = t10;
    $[75] = t33;
    $[76] = t34;
    $[77] = t35;
    $[78] = type;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  return t36;
}
export function ButtonGroup(t0) {
  const $ = _c(7);
  let props;
  let ref;
  if ($[0] !== t0) {
    ({
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = ref;
  } else {
    props = $[1];
    ref = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      flexWrap: "nowrap",
      alignItems: "stretch",
      "& > *": {
        flexGrow: "1",
        "&:not(:first-of-type):not(:last-of-type)": {
          borderRadius: 0
        },
        "&:not(:last-of-type):not(:first-of-type)": {
          borderRadius: 0
        },
        "&:not(:last-of-type):not(:only-of-type)": {
          marginRight: "1px"
        },
        "&:first-of-type:not(:last-of-type)": {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0
        },
        "&:last-of-type:not(:first-of-type)": {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0
        }
      }
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props || $[5] !== ref) {
    t2 = <Box ref={ref} {...props} __css={t1} />;
    $[4] = props;
    $[5] = ref;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
interface RoundButtonProps {
  tooltip;
  icon: any;
  onClick?: (any) => void;
  color?: string;
  className?: string;
  inactiveColor?: string;
  sx?: any;
}
export const RoundButton = function RoundButton(t0) {
  const $ = _c(43);
  const {
    ref,
    tooltip,
    icon,
    onClick,
    color: t1,
    inactiveColor: t2,
    className,
    sx
  } = t0;
  const buttonColor = t1 === undefined ? "primary" : t1;
  t2 === undefined ? "gray.5" : t2;
  const theme = React.useContext(ThemeContext) as Theme;
  const isDark = theme.mode === "dark";
  let t3;
  if ($[0] !== buttonColor) {
    t3 = {
      success: "green",
      warning: "yellow",
      alert: "red",
      primary: "primary_",
      secondary: "gray"
    }[buttonColor.split(".")[0]] || buttonColor;
    $[0] = buttonColor;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const colorScale = t3;
  let t4;
  if ($[2] !== colorScale) {
    t4 = {
      gray: 1,
      red: 5
    }[colorScale] || 8;
    $[2] = colorScale;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const darkness = t4;
  const baseColorN = darkness + (isDark ? false ? 4 : 1 : 0);
  const t5 = baseColorN + (isDark ? 1 : 1);
  let t6;
  if ($[4] !== t5) {
    t6 = clamp(t5, 0, 9);
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const activeColorN = t6;
  isDark ? 1 : 2;
  let bg;
  let borderColor;
  let color;
  let darkenColor;
  let t7;
  let t8;
  if ($[6] !== activeColorN || $[7] !== baseColorN || $[8] !== colorScale || $[9] !== theme) {
    const baseColor = themeGet(`colors.${colorScale}.${baseColorN}`)({
      theme
    });
    let t9;
    if ($[16] !== activeColorN || $[17] !== colorScale || $[18] !== theme) {
      t9 = themeGet(`colors.${colorScale}.${activeColorN}`)({
        theme
      });
      $[16] = activeColorN;
      $[17] = colorScale;
      $[18] = theme;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    darkenColor = t9;
    bg = baseColor;
    borderColor = baseColor;
    t7 = Color(bg).contrast(Color(theme.colors.black));
    t8 = Color(bg).contrast(Color(theme.colors.white));
    $[6] = activeColorN;
    $[7] = baseColorN;
    $[8] = colorScale;
    $[9] = theme;
    $[10] = bg;
    $[11] = borderColor;
    $[12] = color;
    $[13] = darkenColor;
    $[14] = t7;
    $[15] = t8;
  } else {
    bg = $[10];
    borderColor = $[11];
    color = $[12];
    darkenColor = $[13];
    t7 = $[14];
    t8 = $[15];
  }
  if (t7 - t8 > 3.9) {
    color = theme.colors.black;
  } else {
    color = theme.colors.white;
  }
  let t9;
  if ($[20] !== color || $[21] !== darkenColor) {
    t9 = {
      color,
      backgroundColor: darkenColor,
      borderColor: darkenColor
    };
    $[20] = color;
    $[21] = darkenColor;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const activeStyle = t9;
  const t10 = `solid 2px ${theme.colors.brand0[isDark ? 7 : 3]}`;
  let t11;
  if ($[23] !== t10) {
    t11 = {
      outline: t10
    };
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== activeStyle || $[26] !== bg || $[27] !== borderColor || $[28] !== color || $[29] !== t11) {
    t12 = {
      borderRadius: "99px",
      cursor: "pointer",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "48px",
      width: "48px",
      color,
      bg,
      borderColor,
      borderStyle: "solid",
      boxShadow: "2px 2px 24px #444",
      "&:active, &:focus, &:hover": activeStyle,
      "&:focus": t11
    };
    $[25] = activeStyle;
    $[26] = bg;
    $[27] = borderColor;
    $[28] = color;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== icon) {
    t13 = <FontAwesomeIcon icon={icon} fixedWidth={true} size="lg" />;
    $[31] = icon;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== className || $[34] !== onClick || $[35] !== ref || $[36] !== sx || $[37] !== t12 || $[38] !== t13) {
    t14 = <Box as="button" className={className} ref={ref} onClick={onClick} __css={t12} sx={sx}>{t13}</Box>;
    $[33] = className;
    $[34] = onClick;
    $[35] = ref;
    $[36] = sx;
    $[37] = t12;
    $[38] = t13;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t14 || $[41] !== tooltip) {
    t15 = <Tippy content={tooltip}>{t14}</Tippy>;
    $[40] = t14;
    $[41] = tooltip;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  return t15;
};
export default Button;